import { UseLtDetailsArgs } from './types';

export const ltDetailsKeys = {
  base: ['ltDetails'],
  household: (householdID: UseLtDetailsArgs['householdID']) => [...ltDetailsKeys.base, householdID],
  ltDetails: (args: UseLtDetailsArgs) => {
    const key = [...ltDetailsKeys.household(args.householdID)];
    if (args.includeScore) key.push('includeScore');
    if (args.includeLiquidAssets) key.push('includeLiquidAssets');
    if (args.includeAnnualExpenses) key.push('includeAnnualExpenses');
    if (args.includePersonalCashItems) key.push('includePersonalCashItems');
    if (args.includeTotalPersonalCash) key.push('includeTotalPersonalCash');
    if (args.includeBusinessCashItems) key.push('includeBusinessCashItems');
    if (args.includeTotalBusinessCash) key.push('includeTotalBusinessCash');
    if (args.includeAfterTaxInvestments) key.push('includeAfterTaxInvestments');
    if (args.includeTotalAfterTaxInvestments)
      key.push('includeTotalAfterTaxInvestments');
    return key;
  },
};
